import React from 'react';
import { Box, Label, Checkbox } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import useAppName from '../../../utils/sitecoreContext/useAppName';
import { ACURA_SITE_NAME } from '../../../utils/constants';
import themeStyles from './ModelFilters.styles';
import { useAppSelector, useAppDispatch } from '../../../core/utils';
import { setPrimaryCalculatorOverriddenIsSellingProvince, setPrimaryCalculatorIncludeFees, selectPrimaryCalculatorPaymentOptions, } from '../../../core/reducers/financialCalculators';
const Container = themeStyles.apply(Box, 'CheckboxContainer');
const FilterCheckboxContainer = themeStyles.apply(Box, 'FilterCheckboxContainer');
const FilterCheckboxUI = ({ checked, onClick, label, fontFamily, name, id }) => (React.createElement(FilterCheckboxContainer, { "data-testid": `cy-${name}-checkbox` },
    React.createElement(Box, { flex: "0 0 20px", style: { marginTop: '-1px' } },
        React.createElement(Checkbox, { containerSize: "small", checked: checked, id: `${name}-${id}`, name: name, onClick: onClick })),
    React.createElement(Label, { htmlFor: `${name}-${id}`, styledProps: { fontFamily, flex: '1 0 0', pr: ['m', 0], lineHeight: '18px', alignSelf: 'center' } }, label)));
const FilterCheckbox = ({ id }) => {
    const { t } = useTranslation();
    const appName = useAppName();
    const dispatch = useAppDispatch();
    const { includeFees, overriddenIsSellingProvince } = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const handleIncludeFeesClick = () => {
        const newValue = !overriddenIsSellingProvince;
        dispatch(setPrimaryCalculatorOverriddenIsSellingProvince(newValue));
        if (!newValue && includeFees) {
            dispatch(setPrimaryCalculatorIncludeFees(newValue));
        }
    };
    const handleIncludeTaxesClick = () => {
        const newValue = !includeFees;
        dispatch(setPrimaryCalculatorIncludeFees(newValue));
        if (newValue) {
            dispatch(setPrimaryCalculatorOverriddenIsSellingProvince(true));
        }
    };
    // TODO: Update this section when fonts are updated across the application.
    let checkboxLabelFontFamily = 'default';
    switch (appName) {
        case ACURA_SITE_NAME:
            checkboxLabelFontFamily = 'headingRegular';
            break;
        default:
            break;
    }
    return (React.createElement(Container, null,
        React.createElement(FilterCheckboxUI, { checked: !!overriddenIsSellingProvince, onClick: handleIncludeFeesClick, label: t('Shared.Common.includeFreightCheckboxLabel'), fontFamily: checkboxLabelFontFamily, name: "fees", id: id }),
        React.createElement(FilterCheckboxUI, { checked: includeFees, onClick: handleIncludeTaxesClick, label: `${t('Shared.Common.includeTaxesCheckboxLabel')}*`, fontFamily: checkboxLabelFontFamily, name: "tax", id: id })));
};
export default FilterCheckbox;
